import { Config } from "../store/APIStore";

let apiCalls: Config = {
  swaggerUrl: process.env.REACT_APP_SWAGGER_URL as string,
  apiUrl: process.env.REACT_APP_API_URL as string,
  analyticsApiUrl: process.env.REACT_APP_ANALYTICS_API_URL as string,
  analyticsSettingsApiUrl: process.env
    .REACT_APP_ANALYTICS_SETTINGS_API_URL as string,
  badgeDesignerUrl: process.env.REACT_APP_BADGE_DESIGNER_URL as string,
  environment: process.env.REACT_APP_ENVIRONMENT as string,
  leadsUrl: process.env.REACT_APP_LEADS_URL as string,
  portalV2Url: process.env.REACT_APP_PORTAL_V2_URL as string,
};
export default apiCalls;
